import React, { useEffect, useState } from 'react'
import Navbar from '../components/Navbar'
import { Box, display } from '@mui/system'
import { Drawer, Grid, IconButton, TextField, Typography } from '@mui/material'
import EmployerSidebar from '../components/Employer/EmployerSidebar'
import { useDispatch, useSelector } from 'react-redux'
import { getUserInformation } from '../actions/userAuth'
import JobForm from '../components/Employer/JobForm'
import SearchIcon from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';
import Layout from '../assets/Layout'
import UserLayout from '../assets/UserLayout'
const JobDraft = () => {
    const { user } = useSelector((state) => ({ ...state }));
    const navigate = useNavigate();
    useEffect(() => {
        if (!localStorage.getItem("user")) {
            navigate('/')
        }
    }, [])

    const handleSearch = (event) => {
        const searchTerm = event.target.value;
    };
    return (
        <>
            <Layout>
                <UserLayout userRole={"employer"}>
                    {/* <Box sx={{ display: 'flex', flexDirection: 'row', my: 8, borderRadius: '10px' }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', width: '100%' }}>Post a Job</Typography>
                        <TextField
                            sx={{ background: '#3665D014', width: '70%', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)', }} // Updated style
                            variant="outlined"
                            size="small"
                            placeholder="Search"
                            onChange={handleSearch}
                            InputProps={{
                                endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                            }}
                        />
                    </Box> */}
                    <Box sx={{ my: 8 }}>
                        <JobForm calledFrom={"draft"} />
                    </Box>
                </UserLayout>
            </Layout>
        </>
    )
}

export default JobDraft;